import React, { useEffect, useState, useRef } from 'react';
import { useOnClickOutside } from '@/src/services/hooks';
import style from './style.module.scss';
import Backdrop from '@/src/views/components/Backdrop';

export default function Modal({
  open = false,
  children,
  handleOutside,
  disableOutside,
}: {
  open?: boolean;
  children?: React.ReactNode;
  handleOutside?: any;
  disableOutside?: boolean;
}) {
  const ref = useRef(document.createElement('div'));
  const [isModalOpen, setModalOpen] = useState(false);
  useOnClickOutside(ref, () => {
    if (disableOutside) return
    if (handleOutside) {
      handleOutside(false);
    }
    setModalOpen(false);
  });

  useEffect(() => {
    setModalOpen(open);
  }, [open]);

  return (
    <>
      <Backdrop open={isModalOpen}>
        {isModalOpen && (
          <div ref={ref} className={style.modal}>
            {children}
          </div>
        )}
      </Backdrop>
    </>
  );
}
